import React from "react";
import { Nav, Navbar } from "react-bootstrap";
import "../stylesheets/NavigationBar.css";

export const NavigationBar: React.FC = () => {
  return (
    <Navbar expand="lg" variant="dark">
      <Navbar.Brand href="/">[KACP3R.COM]</Navbar.Brand>
      <Navbar.Toggle aria-controls="responsive-navbar-nav" />
      <Navbar.Collapse id="responsive-navbar-nav">
        <Nav className="ml-auto">
          <Nav.Item>
            <Nav.Link href="/">HOME</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link href="/about">ABOUT</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link href="/projects">PROJECTS</Nav.Link>
          </Nav.Item>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
};
